<div class="agpr-chartBlock-wrapper">
    @if (isExporting) {
        <div class="agpr-chartBlock-exporting" [agprLoading]="isExporting"></div>
    }
    <div
        [id]="id"
        class='agpr-block agpr-chartBlock agpr-contextMenu-parent'
        [ngClass]="{
            'agpr-block--cannot-move': !block.canMove,
            'agpr-chartBlock--preview': preview
        }"
        role="group"
        [attr.aria-label]="displayElement?.title + ' Chart. ' + ('Reports.chart.keyboardNavigationDescription' | localize)"
        tabindex="0"
    >
        <div
            *ngIf="actionable && !preview"
            class="agpr-block-dragHandle"
            role="button"
            (keydown)="dragKeydown($event)"
            tabindex="0"
            [attr.aria-label]="'Reports.chart.dragHandle.ariaLabel' | localize"
        >
            <span class="fa-kit fa-agpr-drag-drop"></span>
        </div>
        <div #exportMenu>
            <ul
                *ngIf="actionable && !preview"
                class="agpr-contextMenu top right"
                role="menu"
                [attr.aria-describedby]="id + '_errors' + ' ' + id + '_dataSource_error'"
            >
                <li
                    role="menuitem"
                    class="agpr-contextMenu-menuItem"
                >
                    <agpr-button
                        [id]="`${id}_edit`"
                        icon="fa-regular fa-duotone fa-pen"
                        (click)="onAction('edit')"
                        tooltip="Reports.chartSetupDialog.editHeading"
                        tooltipPosition="top"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                </li>
                <li
                    role="menuitem"
                    class="agpr-contextMenu-menuItem"
                >
                    <agpr-button
                        [id]="`${id}_duplicate`"
                        icon="fa-regular fa-duotone fa-layer-plus"
                        class="agpr-block-contextButton"
                        (click)="onAction('duplicate')"
                        tooltip="Reports.chartSetupDialog.duplicate"
                        tooltipPosition="top"
                        [style]="buttonTypes.contextMenu"
                    ></agpr-button>
                </li>
                <li
                    role="menuitem"
                    class="agpr-contextMenu-menuItem"
                >
                    <agpr-chart-export-menu
                        [id]="`${id}_export`"
                        class="agpr-chartBlock-reportExportIcon"
                        [supportedFormats]="[ 'png', 'jpg', 'svg', 'csv', 'json', 'print' ]"
                        (exportMenuClicked)="chartExport($event)"
                        [tooltip]="'Reports.chartSetupDialog.exportHeading'"
                        tooltipPosition="top"
                        iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    >
                    </agpr-chart-export-menu>
                </li>
                <li
                    role="menuitem"
                    class="agpr-contextMenu-menuItem"
                >
                    <agpr-button
                        [id]="`${id}_delete`"
                        icon="fa-regular fa-duotone fa-trash-can"
                        class="agpr-block-contextButton agpr-block-contextButton--topRight"
                        (click)="onAction('delete')"
                        tooltip="Reports.chartSetupDialog.deleteChart"
                        tooltipPosition="top"
                        [style]="buttonTypes.contextMenu"
                    >
                    </agpr-button>
                </li>
            </ul>
        </div>
        <div   class="agpr-block-content agpr-chartBlock-content"
>
            <div
                *ngIf="!renderable"
                class='agpr-block-placeholder'
            >
                <span class="fa agpr-block-placeholderIcon {{ block.type.icon }}" aria-hidden="true"></span>
                <span class="agpr-block-placeholderLabel">{{ block.type.label | localize }}</span>
            </div>
            <!-- chart-->
            <div
                *ngIf="preview && series"
                class="agpr-chartBlock-watermark"
            >
                {{ 'Reports.chart.sampleData' | localize }}
            </div>

            <div class="agpr-coverageMetricChartBlock-container">
                @if (series && displayElement) {
                    <div class="agpr-coverageMetricChartBlock">
                        <agpr-coverage-metric-chart
                            #chart
                            [displayElement]="displayElement"
                            [dateChartLabelOptions]="chartOptions"
                            [series]="series"
                            (dataChange)="changeDetectorRef.detectChanges()"
                        ></agpr-coverage-metric-chart>
                    </div>
                }
                <agpr-message
                    *ngIf="!series && preview"
                    class="agpr-coverageMetricChart-noContentMessage"
                    [id]="id + '_dataSource_error'"
                    [severity]="messageSeverityEnum.info"
                >
                    {{ 'Reports.chart.noDataSource' | localize }}
                </agpr-message>
                <agpr-message
                    *ngIf="!series && !preview"
                    class="agpr-coverageMetricChart-noContentMessage"
                    [id]="id + '_dataSource_error'"
                    [severity]="messageSeverityEnum.error"
                >
                    {{ 'Reports.error.folderRemoved' | localize }}
                </agpr-message>
            </div>
        </div>
        <button
            class="gridster-item-resize gridster-item-resize--right"
            (keydown)="resizeKeydown($event)"
            [attr.aria-label]="'Dashboard.chart.resizeChart'"
        >
            <span
                class="gridster-item-icon--bottomRight fa-kit fa-agpr-resize-diagonal"
                role="img"
            ></span>
        </button>
        <div
            class="agpr-block-hoverBorder"
        >
        </div>
    </div>
<div>
<div *ngIf="block.errors?.length > 0" class="agpr-blockError" [id]="id + '_errors'">
    <li *ngFor="let error of block.errors">
        <agpr-form-message>
            {{ error | localize }}
        </agpr-form-message>
    </li>
</div>
